import React, {useEffect, useState} from 'react';
import {
    Button,
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    FormControlLabel,
    Checkbox,
    CircularProgress,
    Box,
} from '@mui/material';
import KeyboardDoubleArrowDownOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowDownOutlined';
import BackupTableOutlinedIcon from '@mui/icons-material/BackupTableOutlined';
import {
    fetchPartnerConnectionFields,
    fetchPartnerConnections,
} from '../../../../API/PartnerRevenue';
import {DEFAULT_CONNECTION_STATS, flattenConnection} from '../connectionDisplay';
import useApi from '../../../../hooks/useApi';
import {toast} from 'react-toastify';

function ApiConnectionsOptionsForm({onGenerate}) {
    const {data: statistics} = useApi(fetchPartnerConnectionFields);

    const [options, setOptions] = useState({stats: DEFAULT_CONNECTION_STATS});
    const [loading, setLoading] = useState(false);

    const loadConnections = async (nextOptions = options) => {
        try {
            setLoading(true);
            const response = await fetchPartnerConnections(nextOptions);
            const list = Array.isArray(response?.data) ? response.data : [];
            onGenerate(list.map((connection) => flattenConnection(connection, nextOptions.stats)));
            setLoading(false);
        } catch (err) {
            toast.error('Oops, there seems to be an error on the server. The technical team has already received information about this. We apologize for the inconvenience and we will let you know when it is fixed.');
            setLoading(false);
            console.error(err);
        }
    };

    useEffect(() => {
        loadConnections();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCheckboxChangeStat = (event) => {
        const {name, checked} = event.target;
        let stats = [...options.stats];
        if (checked) {
            stats.push(name);
        } else {
            stats = stats.filter((item) => item !== name);
        }
        setOptions({...options, stats});
    };

    return (
        <Grid container spacing={2} sx={{width: '100%', marginLeft: '0px'}}>
            <Accordion sx={{width: '100%'}}>
                <AccordionSummary
                    expandIcon={<KeyboardDoubleArrowDownOutlinedIcon/>}
                    sx={{backgroundColor: '#f0f3f5', width: '100%'}}
                >
                    Options
                </AccordionSummary>
                <AccordionDetails sx={{width: '100%'}}>
                    <Grid item xs={12} md={12} sx={{width: '100%', margin: '25px 0 25px auto'}}>
                        <Grid item xs={12} md={12}>
                            {Object.keys(statistics).length !== 0 ? (<strong>Data</strong>) : ''}
                        </Grid>
                        {statistics.map((statistic, index) => (
                            <FormControlLabel
                                key={index}
                                control={
                                    <Checkbox
                                        checked={options.stats.includes(statistic.key)}
                                        onChange={handleCheckboxChangeStat}
                                        name={statistic.key}
                                    />
                                }
                                label={statistic.value}
                            />
                        ))}
                    </Grid>
                </AccordionDetails>
            </Accordion>

            <Grid item xs={6} md={6}>
                <Button
                    size="large"
                    startIcon={<BackupTableOutlinedIcon fontSize="small"/>}
                    onClick={() => loadConnections()}
                    variant="contained"
                    color="primary"
                    sx={{marginLeft: '-15px'}}
                >
                    Show Connections
                </Button>
            </Grid>
            {loading &&
                <Grid item xs={12} md={12}>
                    <Box justifyContent="center" textAlign="center" alignItems="center">
                        <CircularProgress size={200}/>
                    </Box>
                </Grid>}
        </Grid>
    );
}

export default ApiConnectionsOptionsForm;
